import { AdvancedTooltip, AdvancedTooltipBase } from './AdvancedTooltip';
import { Atlas } from './Atlas';
import { Dash } from './Dash';
import { InvisualFilter } from './InvisualFilter';
import { Style } from './Style';
import { Table } from './Table';
import { Tooltip } from './Tooltip';
import { Map } from './Map';
import { Chart } from './Chart';
import { Dimensions } from './Dimensions';
import { Fields } from './Fields';
import { Export } from './Export';
import { Context } from './Context';
import { Data } from './Data';
import { Report } from './Report';
import { UpdatePossible } from './UpdatePossible';
import { UpdateOptions } from './UpdateOptions';
import { LineChart } from '@23degrees/charts';
import { LayoutContainer } from './Layout';

export interface Charts23 {
  lineChart?: LineChart;
}

export interface INodeProp {
  id: string;
  [key: string]: any;
}

export interface IEChartOptions {
  version: number;
  advancedEdit: number;
}
export interface ISankeyOptions extends IEChartOptions {
  defaultNode: INodeProp;
  customNodes: INodeProp[];
  levelNodes: INodeProp[];
  labelPosition: 'inside' | 'outside';
  orient: 'horizontal' | 'vertical';
}

export interface ECSanKey {
  version: number;
  editorOptions: ISankeyOptions;
  eChartOptions: any;
}

export enum EChartType {
  Sankey = 'echart-sankey',
  Scatter = 'echart-scatter',
  Gauge = 'echart-gauge',
}

// export type TEChartSubType = `${EChartType}`;
export type EChartSubType = 'sankey' | 'scatter' | 'gauge';

export interface EChart {
  subType: EChartSubType;
  sankey?: ECSanKey;
}

export interface TypeSpecific {
  dataId?: string;
  version: number;

  forceLong?: boolean;
  inlineData?: boolean;
  wideFieldName?: string;

  data?: Data;
  context?: Context;

  export?: Export;
  fields?: Fields;
  sorting?: any;
  dimensions?: Dimensions;
  chart?: Chart;
  eChart?: EChart;
  map?: Map;
  table?: Table;
  report?: Report;
  style?: Style;
  tooltip?: Tooltip;
  advancedTooltip?: AdvancedTooltip;
  hoverTooltip?: AdvancedTooltipBase;
  atlas?: Atlas;
  dash?: Dash;
  inVisualFilter?: InvisualFilter[];
  smartFilters?: any[]; // NEEDS TO BE DEFINED
  smartFunctions?: any[]; // NEEDS TO BE DEFINED
  collection?: {
    sort: {
      field: string;
      order: number;
    };
  };

  importSettings?: any;

  noDataMessages?: any;

  layout?: LayoutContainer;

  embed?: {
    mode: 'responsive' | 'fixed' | 'flexible' | 'external';
    width: number;
    height: number;
    lazy: boolean;
    branchFields: string[];
  };

  permissions?: any;

  updatePossible?: UpdatePossible;
  updateOptions?: UpdateOptions;

  isChild?: boolean; // child indicator for frontend and backend

  shortcutContent?: any;

  previewSettings?: any; // to be defined

  // TODO: CHECK THIS just mocking whats breaking the app
  autocreateGroups?: boolean;
  format?: any;
  updateInterval?: any;
  uniqueFields?: any;

  // New 23 Package Charts
  charts23?: Charts23;

  // Optional Crawler Slug
  updateCrawlerSlug?: string;

  // indicator for bucket storage
  useBucket?: boolean;
}
